export default __webpack_public_path__ + "static/media/vip4.a9c2367f.webp";